import {
  initGlobalState,
  registerMicroApps,
  runAfterFirstMounted,
  start
} from "qiankun";
import "util/util";
// for angular subapp
import "zone.js";
import { setBase } from "./base/base.js";
import { setBaseWithoutToken } from "./base/baseWithoutToken.js";
import "./index.less";
/**
 * React and Vue subapp.
 */
import render from "./render/ReactRender";
//Keycloak auth
import { Auth } from "./util/auth";

// import './assets/images';


function genActiveRule(routerPrefix) {
  return (location) => location.hash.startsWith("#"+routerPrefix);
}

function bootstrap(isToken) {
  if (isToken) {
    setBaseWithoutToken();
  } else {
    setBase();
  }
  /**
   * Step1
   */
  render({ appContent: "", loading: true });

  /**
   * Step2
   */
  registerMicroApps(
    [
      {
        name: "committee-angular",
        entry: process.env.COMMITTEE_URL,
        render,
        activeRule: genActiveRule("/committee-angular"),
      },
      {
        name: "alumni-angular",
        entry: process.env.ALUMNI_MODULE_URL,
        render,
        activeRule: genActiveRule("/alumni-angular"),
      },
      {
        name: "counsellor-angular",
        entry: process.env.COUNSELLOR_MODULE_URL,
        render,
        activeRule: genActiveRule("/counsellor-angular"),
      },
      {
        name: "assessment-angular",
        entry: process.env.ASSESSMENT_MODULE_URL,
        render,
        activeRule: genActiveRule("/assessment-angular"),
      },
      {
        name: "payroll-angular",
        entry: process.env.PAYROLL_URL,
        render,
        activeRule: genActiveRule("/payroll-angular"),
      },
      {
        name: "canteen-angular",
        entry: process.env.CANTEEN_URL,
        render,
        activeRule: genActiveRule("/canteen-angular"),
      },
      {
        name: "analytics-angular",
        entry: process.env.ANALYTICS_URL,
        render,
        activeRule: genActiveRule("/analytics-angular"),
      },
      {
        name: "profile-angular",
        entry: process.env.USERPROFILE_URL,
        render,
        activeRule: genActiveRule("/profile-angular"),
      },
      {
        name: "accreditation-angular",
        entry: process.env.ACCREDITATION_URL,
        render,
        activeRule: genActiveRule("/accreditation-angular"),
      },
      {
        name: "univer-accreditation-angular",
        entry: process.env.UNIVER_ACCREDITATION_URL,
        render,
        activeRule: genActiveRule("/univer-accreditation-angular"),
      },
      {
        name: "leave-management-angular",
        entry: process.env.LEAVE_MODULE_URL,
        render,
        activeRule: genActiveRule("/leave-management-angular"),
      },
      {
        name: "hostel-management-angular",
        entry: process.env.HOSTEL_MODULE_URL,
        render,
        activeRule: genActiveRule("/hostel-management-angular"),
      },
      {
        name: "attendance-angular",
        entry: process.env.ATTENDANCE_MODULE_URL,
        render,
        activeRule: genActiveRule("/attendance-angular"),
      },
      {
        name: "content-management-angular",
        entry: process.env.CONTENT_MANAGEMENT_MODULE_URL,
        render,
        activeRule: genActiveRule("/content-management-angular"),
      },
      {
        name: "admission-angular",
        entry: process.env.ADMISSION_URL,
        render,
        activeRule: genActiveRule("/admission-angular"),
      },
      {
        name: "collaboration-angular",
        entry: process.env.COLLABORATION_URL,
        render,
        activeRule: genActiveRule("/collaboration-angular"),
      },
      {
        name: "timetable-angular",
        entry: process.env.TIMETABLE_MODULE_URL,
        render,
        activeRule: genActiveRule("/timetable-angular"),
      },
      {
        name: "naac-angular",
        entry: process.env.NAAC_URL,
        render,
        activeRule: genActiveRule("/naac-angular"),
      },
      {
        name: "user-management-angular",
        entry: process.env.USER_MANAGEMENT_URL,
        render,
        activeRule: genActiveRule("/user-management-angular"),
      },
      {
        name: "transportation-angular",
        entry: process.env.TRANSPORTATION_URL,
        render,
        activeRule: genActiveRule("/transportation-angular"),
      },
      {
        name: "placement-angular",
        entry: process.env.PLACEMENT_URL,
        render,
        activeRule: genActiveRule("/placement-angular"),
      },
      {
        name: "lesson-plan-angular",
        entry: process.env.LESSON_PLAN_MODULE_URL,
        render,
        activeRule: genActiveRule("/lesson-plan-angular"),
      },
      {
        name: "faculty-performance-angular",
        entry: process.env.FACULTY_PERFORMACE_URL,
        render,
        activeRule: genActiveRule("/faculty-performance-angular"),
      },
      {
        name: "course-management-angular",
        entry: process.env.COURSE_MANAGEMENT_URL,
        render,
        activeRule: genActiveRule("/course-management-angular"),
      },
      {
        name: "dashboard-angular",
        entry: process.env.DASHBOARD_URL,
        render,
        activeRule: genActiveRule("/dashboard-angular"),
      },
      {
        name: "mcq-angular",
        entry: process.env.MCQ_URL,
        render,
        activeRule: genActiveRule("/mcq-angular"),
      },{
        name: "study-abroad-angular",
        entry: process.env.STUDY_ABROAD_MODULE_URL,
        render,
        activeRule: genActiveRule("/study-abroad-angular"),
      },
      {
        name: "reports-angular",
        entry: process.env.REPORTS_URL,
        render,
        activeRule: genActiveRule("/reports-angular"),
      },
      {
        name: "integration-angular",
        entry: process.env.DHI_INTEGRATION_URL,
        render,
        activeRule: genActiveRule("/integration-angular"),
      },
      {
        name: "college-examination-angular",
        entry: process.env.COLLEGE_EXAMINATION_URL,
        render,
        activeRule: genActiveRule("/college-examination-angular"),
      },
      {
        name: "miscellaneous-angular",
        entry: process.env.MISCELLANEOUS_URL,
        render,
        activeRule: genActiveRule("/miscellaneous-angular"),
      },
      {
        name: "library-angular",
        entry: process.env.LIBRARY_URL,
        render,
        activeRule: genActiveRule("/library-angular"),
      },
      {
        name: "tripsandexpenses-angular",
        entry: process.env.TRIPANDEXPENSES_URL,
        render,
        activeRule: genActiveRule("/tripsandexpenses-angular"),
      },{
        name: "auth-mf",
        entry: process.env.AUTH_URL,
        render,
        activeRule: genActiveRule("/auth-mf"),
      },
      {
        name: "issue-tracker",
        entry: process.env.ISSUE_TRACKER_URL,
        render,
        activeRule: genActiveRule("/issue-tracker"),
      },
      {
        name: "pre-admission-angular",
        entry: process.env.PRE_ADMISSION_URL,
        render,
        activeRule: genActiveRule("/pre-admission-angular"),
      },
      {
        name: "refresh",
        entry: "refresh",
        render,
        activeRule: genActiveRule("/refresh"),
      }

    ],
    {
      beforeLoad: [
        (app) => {
          console.log(
            "[LifeCycle] before load %c%s",
            "color: green;",
            app.name
          );
        },
      ],
      beforeMount: [
        (app) => {
          console.log(
            "[LifeCycle] before mount %c%s",
            "color: green;",
            app.name
          );
        },
      ],
      afterUnmount: [
        (app) => {
          console.log(
            "[LifeCycle] after unmount %c%s",
            "color: green;",
            app.name
          );
        },
      ],
    }
  );

  /**
   * Step3
   */
  // setDefaultMountApp('/analytics');
  const { onGlobalStateChange, setGlobalState } = initGlobalState({
    user: "qiankun",
  });

  onGlobalStateChange((value, prev) =>
{
 //   console.log("[onGlobalStateChange - master]:", value, prev, window.location)
}

  );

  setGlobalState({
    ignore: "master",
    user: {
      name: "master",
    },
  });
  /**
   * Step4
   */
  start({prefetch:false});

  runAfterFirstMounted(() => {

  });
}

Auth.checkIfUniversity().then((isUniversity) => {

  const level = isUniversity ? 'UNIVERSITY' : 'COLLEGE';

  Auth.setAcademicLevel(level);
  Auth.setSelectedAcademicLevel(level);
  Auth.setSourceAcademicLevel(level);

  loginCheck();

}).catch((error) => {

  Auth.setAcademicLevel('COLLEGE');
  Auth.setSelectedAcademicLevel('COLLEGE');
  Auth.setSourceAcademicLevel('COLLEGE');

  loginCheck();
});


function loginCheck() {

  const locationB = Auth.getLocationNavigate();
  const locationVar = window.location + '';
  if (locationVar.indexOf('studentregistration;routekeyrole=registrationlink;tenantId=') > -1
    || locationVar.includes('studentpreregistration') || locationVar.includes('loginpagetwostage')
    || locationVar.includes('configuration/transactionstatus')
    || locationVar.includes('studentlogin/studentregistrationpayment;routekeyrole=registrationlink')
    // || locationVar.includes('admission-angular/studentlogin/studentdepositcategorypayment')
    || locationVar.indexOf('instructionPage;formName=regular_registration;tenantId=') > -1
    || locationVar.indexOf('instructionPage;formName=pre_admission_registration;tenantId=') > -1
    || locationVar.indexOf('instructionPage;formName=alumni_registration;tenantId=') > -1
    || locationVar.indexOf('retrievestudentregistrationfrom;routekeyrole=registrationlink;tenantId=') > -1
      || locationVar.includes('prospect-student/prospectstudent/onlineapplication/vjec')
      || locationVar.indexOf('prospect-student/prospectstudent/registrationform') > -1
      || locationVar.indexOf('/loginpagetwostage/dhi_local') > -1
      || locationVar.includes('auth-mf/cred/forgot-password') 
      || locationVar.includes('auth-mf/cred/password_reset')
     || locationVar.includes('mcq-angular/anonymous/feedback') 
    ) {
    const string = locationVar.split(';');
    let strings = string[0].split('/');
    Auth.setSelectedTenantId(strings[3]);
    start();
    let routingurl='';
      routingurl = string[0].split('#')[1].includes("auth-mf/") ? string[0].split('#')[1] : "/" + locationVar.split('#/')[1];
    if(routingurl.includes("auth-mf/") || routingurl.includes("mcq-angular/")){
      history.pushState(null,routingurl, "/#" + routingurl);
    }else{
      if(locationVar.indexOf('instructionPage;formName=pre_admission_registration;tenantId=') > -1 || locationVar.includes('configuration/transactionstatus') 
      || locationVar.includes('loginpagetwostage') || locationVar.indexOf('loginpagetwostage/dhi_local') > -1 || locationVar.includes('studentpreregistration')){
        console.log("Enter pre admision");
        history.pushState(null,routingurl, "/#/pre-admission-angular" + routingurl);
      }else{
         history.pushState(null,routingurl, "/#/admission-angular" + routingurl);}
    }
   
    bootstrap(true);
  } else if((locationVar && locationVar.includes('admission-angular/studentlogin/selfservice')) || 
  locationVar.includes('admission-angular/studentlogin/studentregistrationpayment') || 
  locationVar.includes('admission-angular/studentlogin/studentdepositcategorypayment')){
    sessionStorage.setItem("fromPayment", "redirectFromPayment");
    init();
  } else if (locationVar.includes('college-examination-angular/student/universityexam/examregistration-new') ||
  locationVar.includes('college-examination-angular/student/universityexam/result')) {
    init();
  } else if (locationB) {
    console.log("loginCheck else if")
    start();
    history.pushState(
      null,
      locationB,
      "/"+Auth.getTenantId()+"/#/" + locationB
    );
    console.log("else if end locationB",window.location)
    bootstrap(true);
  } else {
    sessionStorage.removeItem("fromPayment");
    console.log("loginCheck else here")
    init();
  }
}




function init() {

  Auth.init()
    .then((data) => {

      Auth.kcUser()
        .then((user) => {

          checkDefaultPath()
          bootstrap(false);
          sessionStorage.removeItem("mfrootLocation");
        })
        .catch((error) => {
          
          console.log("error in loading user : ", error);
        });
    })
    .catch((error) => {
      console.log("error ", error);
    });
}

function checkDefaultPath() {
  let getDefaultPath = window.sessionStorage.getItem("fromPayment");
  const locationVar = window.location + ''; 
  if(locationVar.includes('admission-angular/studentlogin/studentregistrationpayment') || 
  locationVar.includes('admission-angular/studentlogin/selfservice') ||
  locationVar.includes('admission-angular/studentlogin/studentdepositcategorypayment')){
    const string = locationVar.split(';');
    let routingurl='';
    routingurl = string[0].split('#')[1].includes("auth-mf/") ? string[0].split('#')[1] : "/" + locationVar.split('#/')[1];
    history.pushState(null,routingurl, "/#" + routingurl);
  } else if (locationVar.includes('college-examination-angular/student/universityexam/examregistration-new') ||
  locationVar.includes('college-examination-angular/student/universityexam/result')) {
    const string = locationVar.split(';');
    let routingurl='';
    routingurl = string[0].split('#')[1].includes("auth-mf/") ? string[0].split('#')[1] : "/" + locationVar.split('#/')[1];
    history.pushState(null,routingurl, "/#" + routingurl);
  }
}




